import { encode } from 'js-base64'

const AUTH = process.env.VUE_APP_BASE_AUTH
const servlet = 'LoginServlet?ps='

// 跳转登录页面url
export const loginSystem = ({ returnUrl, serviceCode, brand, language } = {}) => {
  let info = {
    returnUrl, serviceCode: 'Parcel', brand, language
  }
  return AUTH + servlet + encode(JSON.stringify(info))
}

/**
 * 新版菜单三级改二级
 * @param {Array} menu
 * @param {String} language
 * @returns {Array}
 */
export const formatMenuList = (menu, language = 'zh') => {
  const getAllList = (list) => {
    const arr = []
    list.forEach(item => {
      // 过滤掉主页权限菜单
      if (item.path && !item.path.includes('homepagePermission') && item.children && item.children.length) {
        item.children.forEach(itx => {
          arr.push({
            resourceKey: language === 'zh' ? itx.titleCn : itx.titleEn,
            titleCn: itx.titleCn,
            titleEn: itx.titleEn,
            path: item.path + '/' + itx.path,
            moduleUUID: item.path + '/' + itx.path
          })
        })
      }
    })
    return arr
  }
  const newMenu = []
  menu.forEach(item => {
    if (item.path && !item.path.includes('homepagePermission') && item.children && item.children.length) {
      newMenu.push({
        isShowBottom: true,
        resourceKey: language === 'zh' ? item.titleCn : item.titleEn,
        titleCn: item.titleCn,
        titleEn: item.titleEn,
        moduleUUID: item.path,
        path: item.path,
        children: getAllList(item.children)
      })
    }
  })
  return newMenu
}

/**
 * 获取正规表达式
 * @param {String} str
 * @returns {String}
 */
export const getRegExp = (str) => {
  switch (str) {
    case 'email':
      return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/
    case 'phone':
      return /^1[3456789]\d{9}$/
    case 'number':
      return /^[0-9]*$/
    case 'english':
      return /^[a-zA-Z]+$/
    case 'chinese':
      return /^[\u4e00-\u9fa5]+$/
    case 'password':
      // 密码必须 6-20 位, 包含数字，大写字母和小写字母
      return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,20}$/
    default:
      return ''
  }
}
